import { render, staticRenderFns } from "./Purchasing.vue?vue&type=template&id=4aafbb6d&scoped=true&"
import script from "./Purchasing.vue?vue&type=script&lang=js&"
export * from "./Purchasing.vue?vue&type=script&lang=js&"
import style0 from "./Purchasing.vue?vue&type=style&index=0&id=4aafbb6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aafbb6d",
  null
  
)

export default component.exports